import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { AppShell } from "~/components/shell/app-shell";
import { safeRedirectPath } from "~/lib/auth-redirect";
import { orpc } from "~/lib/orpc";

export const Route = createFileRoute("/_dashboard")({
  // Every dashboard route reads `me.get` through `useMe()`, which suspends.
  // Prefetching it here — once, for the whole subtree — is what keeps a
  // navigation from remounting the entire app.
  beforeLoad: async ({ context, location }) => {
    try {
      await context.queryClient.ensureQueryData(orpc.me.get.queryOptions());
    } catch (err) {
      const code = (err as { code?: string }).code;
      if (code === "UNAUTHORIZED" || code === "NOT_AUTHENTICATED") {
        // Carry the deep link through sign-in (the walk-in email's
        // « Répondre » → /arrivee/<id>), so the person lands on it, not on
        // the home page. `safeRedirectPath` drops `/` and anything unsafe.
        // eslint-disable-next-line @typescript-eslint/only-throw-error
        throw redirect({
          to: "/sign-in",
          search: { redirect: safeRedirectPath(location.href) },
        });
      }
      throw err;
    }
  },
  component: DashboardLayout,
});

function DashboardLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
